"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _classnames = _interopRequireDefault(require("classnames"));

var _moment = _interopRequireDefault(require("moment"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _Flipdown = _interopRequireDefault(require("./Flipdown"));

require("../styles/_countdown.scss");

var _basePath = _interopRequireDefault(require("../../../../../../../common/constants/basePath"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SMALL_BREAKPOINT = 550;
var HIDE_COUNTDOWN_STATUSES = ['ON_HOLD', 'PENDING_MASTER'];

function getRushEdit(currentVersion) {
  var rushEdit = (0, _lodash.default)(currentVersion, 'appliedAddons.RUSH_EDIT.value');
  var rushEditStatus = (0, _lodash.default)(currentVersion, 'appliedAddons.RUSH_EDIT.status');
  return {
    rushEdit: rushEdit,
    rushEditStatus: rushEditStatus
  };
}

function getDate(timestamp) {
  // ISO String
  if (isNaN(timestamp)) {
    return new Date(timestamp).getTime();
  }

  return parseInt(timestamp, 10);
}

var Countdown = /*#__PURE__*/function (_Component) {
  _inherits(Countdown, _Component);

  var _super = _createSuper(Countdown);

  function Countdown(props) {
    var _this;

    _classCallCheck(this, Countdown);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getSubmittedAt", (0, _memoizeOne.default)(function (currentVersion) {
      return getDate(currentVersion.dueDate);
    }));

    _defineProperty(_assertThisInitialized(_this), "getTitle", function (_ref) {
      var rushEdit = _ref.rushEdit,
          rushEditStatus = _ref.rushEditStatus;
      var currentOutput = _this.props.currentOutput;
      var status = currentOutput.status;

      if (status === 'ON_HOLD') {
        return 'VIDEO ON HOLD';
      }

      if (status === 'PENDING_MASTER') {
        return 'YOUR VIDEO IS IN QUEUE';
      }

      if (!rushEdit || rushEditStatus !== 'APPROVED') {
        return 'EDITING IN-PROGRESS';
      }

      return (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          name: rushEdit === 'FAST' ? 'rushedit' : 'rushsuper',
          color: "monkey",
          size: 40
        }), "RUSH EDIT (".concat(rushEdit === 'FAST' ? 'FAST' : 'SUPER FAST', ") IN-PROGRESS"))
      );
    });

    _defineProperty(_assertThisInitialized(_this), "countDownDisclaimer", function () {
      var _this$props = _this.props,
          currentOutput = _this$props.currentOutput,
          masterOutput = _this$props.masterOutput;
      var status = currentOutput.status;

      if (status === 'ON_HOLD') {
        return (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Your video is on hold. We might be missing a few things, please contact ", /*#__PURE__*/_react.default.createElement("a", {
            href: "mailto: support@shootsta.com "
          }, "support@shootsta.com"), " or ", /*#__PURE__*/_react.default.createElement("a", {
            className: "link-to",
            rel: "noopener noreferrer",
            target: "_blank",
            href: "https://shootsta.com/en-au/contact/"
          }, "call us"))
        );
      }

      if (status === 'PENDING_MASTER' && masterOutput) {
        var name = masterOutput.name,
            videoId = masterOutput.videoId,
            outputId = masterOutput.outputId;
        return (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "We haven't started this video yet because the master needs to be approved first. View ", /*#__PURE__*/_react.default.createElement("a", {
            className: "link-to",
            rel: "noopener noreferrer",
            target: "_blank",
            href: "".concat(_basePath.default, "/").concat(videoId, "/").concat(outputId)
          }, name))
        );
      }

      return (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "*This is an estimate only and should be used for reference only. For more information about your video, please contact your dedicated Account Manager or our friendly Support Staff.")
      );
    });

    var _currentVersion = props.currentVersion;

    var _getRushEdit = getRushEdit(_currentVersion),
        _rushEdit = _getRushEdit.rushEdit,
        _rushEditStatus = _getRushEdit.rushEditStatus;

    var endTime = _this.getSubmittedAt(_currentVersion);

    _this.state = {
      endTime: endTime,
      rushEdit: _rushEdit,
      rushEditStatus: _rushEditStatus
    };
    return _this;
  }

  _createClass(Countdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var endTime = this.state.endTime;
      var currentOutput = this.props.currentOutput;
      var status = currentOutput.status;

      if (HIDE_COUNTDOWN_STATUSES.includes(status)) {
        return;
      }

      this._flipdown = new _Flipdown.default(Math.trunc(endTime / 1000)).start();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref2) {
      var _this2 = this;

      var prevDueDate = _ref2.currentVersion.dueDate;
      var _this$props2 = this.props,
          currentVersion = _this$props2.currentVersion,
          currentOutput = _this$props2.currentOutput;

      if (prevDueDate === currentVersion.dueDate) {
        return;
      }

      var _getRushEdit2 = getRushEdit(currentVersion),
          rushEdit = _getRushEdit2.rushEdit,
          rushEditStatus = _getRushEdit2.rushEditStatus;

      var endTime = this.getSubmittedAt(currentVersion);
      var status = currentOutput.status;
      this.setState({
        rushEdit: rushEdit,
        endTime: endTime,
        rushEditStatus: rushEditStatus
      }, function () {
        if (HIDE_COUNTDOWN_STATUSES.includes(status)) {
          return;
        }

        _this2._flipdown.updateTime(endTime / 1000);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          containerWidth = _this$props3.size.width,
          currentOutput = _this$props3.currentOutput;
      var _this$state = this.state,
          endTime = _this$state.endTime,
          rushEdit = _this$state.rushEdit,
          rushEditStatus = _this$state.rushEditStatus;
      var status = currentOutput.status;
      var showExpectedDate = !HIDE_COUNTDOWN_STATUSES.includes(status);
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('countdown', {
            'countdown--fast-edit': rushEdit && rushEditStatus === 'APPROVED',
            'countdown--small': containerWidth < SMALL_BREAKPOINT
          })
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "countdown__inner"
        }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement("h1", {
          className: "countdown__header"
        }, this.getTitle({
          rushEdit: rushEdit,
          rushEditStatus: rushEditStatus
        }))), /*#__PURE__*/_react.default.createElement("div", {
          id: "flipdown",
          className: "flipdown"
        }), showExpectedDate && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h1", {
          className: "countdown__expected"
        }, "Expected Due Date*"), /*#__PURE__*/_react.default.createElement("h1", {
          className: "countdown__date"
        }, (0, _moment.default)(endTime).format('dddd, Do MMMM [by] h:mma')))), /*#__PURE__*/_react.default.createElement("p", {
          className: "countdown__disclaimer"
        }, this.countDownDisclaimer()))
      );
    }
  }]);

  return Countdown;
}(_react.Component);

exports.default = Countdown;